import {Box, Typography, CircularProgress} from '@mui/material';
import styles from './AppLoading.module.scss';
import { useTranslation } from 'react-i18next';
import AppLoadingLogo from '../appLogo/AppLoadingLogo';

export default function AppLoading () {
    const {t} = useTranslation();

    return (<Box className={styles.container}>
       <AppLoadingLogo/>
       <Box className={styles.horizontalContainer}>
            <CircularProgress size={20}/>
            <Typography className={styles.loadingText}>
                {t("LOADING")}
            </Typography>
       </Box>
    </Box>);
}